import React, { useEffect } from "react";
import Breadcrumb from "../components/Breadcrumb";
import { Helmet } from "react-helmet";
import Layout from "../components/Layout";
import Mail from "../components/Mail";
import { initialize } from "../store/pagedata";
import { useDispatch } from "react-redux";

const ContactUs = () => {
  const dispatch = useDispatch();
  const destination = "edhrec@edhrec.com";

  useEffect(() => {
    dispatch(initialize());
  }, []);

  return (
    <Layout>
      <Helmet>
        <meta name="description" content="Contact the EDHREC team" />
        <meta name="keywords" content="EDHREC,contact,email,message" />
        <title>Contact Us | EDHREC</title>
      </Helmet>
      <Breadcrumb breadcrumb={[{ "/contact-us": "Contact Us" }]} />
      <h4 className="page-heading">Contact Us</h4>
      <Mail
        description={
          <p>
            {"Use the form below, or email us at "}
            <a href={`mailto:${destination}`} rel="noreferrer" target="_blank">
              {destination}
            </a>
            .
          </p>
        }
        destination={destination}
      />
    </Layout>
  );
};

export default ContactUs;
